import axios from 'axios';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import TableButton from '../Shared/Buttons/TableButton';
import '../Shared/CSS/table.css';
import { PaginationButton } from '../Shared/Pagination/PaginationButton';
import PropertyPopup from '../Shared/Popups/PropertyPopup';

const CustomerTable = ( props: any ) => {

    console.log( 'in customer table: ', props );
    const itemPerPage = 10;

    const [ popupOpen, setPopupOpen ] = useState( false );
    const [ propertyData, setPropertyData ] = useState( [ ] );

    const [ currentData, setCurrentData ] = useState( props.customerInfo.slice( 0, itemPerPage ) );

    const popupHandler = ( ) => {

        setPopupOpen( popupOpen => !popupOpen );

    }

    const currentDataHandler = ( currentPage: number ) => {
        console.log( 'currentPage ', currentPage );
        setCurrentData( (currentData: any) => props.customerInfo.slice( ( currentPage - 1 )*itemPerPage, ( currentPage - 1 )*itemPerPage + itemPerPage) );

    }

    const setProperty = ( property: any ) => {

        setPropertyData( property );

        if ( property ) {

            popupHandler( );

        }

    }

    useEffect( ( ) => {


    }, [ currentData ] );
    

    const toggleContacted = ( id: any ) => {
        const tokenConfig = {
            // "x-auth-token": localStorage.getItem("token"),
            headers: {
                accept: "/*/",
                Authorization: "Bearer " + localStorage.getItem("shreeDevToken"),
            },
        };

        axios.post( `https://shreee-development-test.herokuapp.com/admin/customer/${ id }`, { }, tokenConfig )
            .then( ( res: any ) => { 

                console.log( 'Contacted' );
                window.location.reload( );

            } )
            .catch( ( e: any ) => {

                console.log( 'error occured ', e );

            } )

    }

    return (

        <CustomerTableWrapper>
        <div className="wrapper">

            <h1> Customers </h1><br/>
  
            <div className="table">
                
                <div className="row header">
                    <div className="cell">
                        SNo.
                    </div>
                    <div className="cell">
                        Customer Name
                    </div>
                    <div className="cell">
                        Contact No.
                    </div>
                    <div className="cell">
                        Property Interested In
                    </div>
                    <div className = 'cell'>
                        Status
                    </div>
                    <div className = 'cell'>
                        Show Property
                    </div>
                    <div className = 'cell'>
                        Mark Contacted
                    </div>
                </div>
                {
                    currentData.map( ( item: any, index: number ) => {

                        return (

                            <div className = 'row' key = { item._id } >
                                <div className = 'cell' data-title = 'SNo'>
                                    { index + 1 }
                                </div>
                                <div className = 'cell' data-title = 'Customer Name'>
                                    { item.name }
                                </div>
                                <div className = 'cell' data-title = 'Phone'>
                                    { item.phone }
                                </div>
                                <div className = 'cell' data-title = 'Plot'>
                                    { item.interestedPropertyId.propertyName }
                                </div>
                                <div className = { `cell ${ item.isContacted ? 'contacted' : 'not-contacted' }` } data-title = 'Status'>
                                    { item.isContacted ? 'Yes' : 'No' }
                                </div>
                                <div className = 'cell' data-title = 'Show Property'>
                                    {/* <button onClick = { ( ) => setProperty( item.interestedPropertyId ) } >show</button> */}
                                    <TableButton actionHandler = { ( ) => setProperty( item.interestedPropertyId ) }
                                    text = 'Show' type = 'normal' />
                                </div>
                                <div className = 'cell' >
                                    {/* <button onClick = { ( ) => toggleContacted( item._id ) }>Done</button> */}
                                    <TableButton actionHandler = { ( ) => toggleContacted( item._id ) }
                                    text = 'Toggle' type = 'blue' />
                                </div>
                            </div>

                        )
                    } )
                } 
                
            </div>
            {
                popupOpen ?
                <div className="popup-model">
                    <PropertyPopup data = { propertyData } popupHandler = { popupHandler } />
                </div>
                :
                ''
            }
               
        </div>
        <div className="pagination-area">
                <PaginationButton itemPerPage = { itemPerPage } data = { props.customerInfo } actionHandler = { currentDataHandler } />    
            </div>
        </CustomerTableWrapper>
    
    )

}

export default CustomerTable;

const CustomerTableWrapper = styled.div`

    .pagination-area {
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;